import { useTheme } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar";
import { tokens } from "../theme";
//import { mockBarData as data } from "../data/mockData";

const BarChart = ({ isDashboard = false, data}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  let theKeys = [];
  let indexByField = "";

  //Extract the keys
  if (data !== null && data.length >0)
  {
    let attrCounter = 0;
    for (let jsonItem of data)
    {

      for (const key in jsonItem) {
        if (jsonItem.hasOwnProperty(key)) { // Ensure the property belongs to the object
          attrCounter = attrCounter + 1;
          if (attrCounter == 1)
          {
            indexByField= key;
          } else 
          {
            if (!key.includes("Color"))
            {
              theKeys.push(key);
            }
          }

        }
    }
      break;
    }
  }

  //console.log(JSON.stringify(data));

  return (
    <ResponsiveBar
      data={data}
      theme={{
        // added
        axis: {
          domain: {
            line: {
              stroke: colors.grey[100],
            },
          },
          legend: {
            text: {
              fill: colors.grey[100],
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[100],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
          },
        },
      }}
      keys={theKeys}
      indexBy={indexByField}
      margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
      padding={0.3}
      valueScale={{ type: "linear" }}
      indexScale={{ type: "band", round: true }}
      colors={{ scheme: "nivo" }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "#38bcb2",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "#eed312",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      borderColor={{
        from: "color",
        modifiers: [["darker", "1.6"]],
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "priority", // changed
        legendPosition: "middle",
        legendOffset: 32,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: isDashboard ? undefined : "food", // changed
        legendPosition: "middle",
        legendOffset: -40,
      }}
      enableLabel={false}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor={{
        from: "color",
        modifiers: [["darker", 1.6]],
      }}
      legends={[
        {
          dataFrom: "keys",
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 120,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: "left-to-right",
          itemOpacity: 0.85,
          symbolSize: 20,
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      role="application"
      barAriaLabel={function (e) {
        return e.id + ": " + e.formattedValue + " in priority: " + e.indexValue;
      }}
      tooltip={(e) => (
        <div
          style={{
            color: colors.blueAccent[500],
            background: "white",
            padding: "5px",
            borderRadius: "3px",
            boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
          }}
        >
          {e.id}: {e.value}
        </div>
      )}
    />
  );
};

export default BarChart;
